module.exports = "/static/images/phone-solid.svg";